export function showLabelSelectDropdownListFooter({ Footer }) {
  return Boolean(Footer)
}
